var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.7826,
    cy: 17.391,
    r: 1.913,
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.026,
    cy: 17.391,
    r: 1.913,
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.826 7.3478v-2.3478c0-0.55228-0.4477-1-1-1h-12.826c-0.55228 0-1 0.44771-1 1v9.0435c0 0.2641 0.21412 0.4782 0.47826 0.4782v0m14.348-7.1739 0.0429 7.1739m-0.0429-7.1739h2.3913m2.4875 9.7433h1.2951c0.5523 0 1-0.4477 1-1v-3.4824m-7.5382 4.4824h-1.9413m-5.0723 0h1.6388m-6.8229 0h-1.6968v0c-0.04917 0-0.08903-0.0399-0.08903-0.089v-2.4804m0 0h8.6087m5.7391 0h0.0429m-5.782 2.5694v-2.5694m0 2.5694h3.4335m-3.4335-2.5694h3.4335m0 2.5694v-2.5694m0 0h2.3485m2.3484-7.1739h1.4348l1.9951 1.9951c0.8661 0.86617 1.3527 2.0409 1.3527 3.2658v0m-4.7826-5.2609v4.2609c0 0.5523 0.4477 1 1 1h3.7826",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.3434190652688b30d5683b2671d2ee70.svg";
export { ForwardRef as ReactComponent };